import React, { ChangeEvent, FunctionComponent } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";

import { TextField } from "components";

export const UtilityBillEditNotesDialog: FunctionComponent<{
  open: boolean;
  onClose: () => void;
  notes: string;
  notesError: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  onSave: () => void;
}> = ({ open, onClose, notes, notesError, onChange, onSave }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      Notes
    </DialogTitle>
    <DialogContent sx={{ px: "24px", width: "500px" }}>
      <Box>
        <TextField
          sx={{ width: "100%" }}
          onChange={onChange}
          value={notes}
          error={notesError}
          helperText={
            notesError
              ? "Notes length should not exceed 250 characters"
              : ""
          }
          multiline
          rows={3}
        />
      </Box>
    </DialogContent>
    <DialogActions>
      <Grid
        container
        alignItems="center"
        justifyContent="flex-end"
        mb={2}
        ml={2}
      >
        <Grid item sx={{ pr: '16px' }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button
            onClick={onSave}
            variant="contained"
            color="primary"
          >
            Save
          </Button>
        </Grid>
      </Grid>
    </DialogActions>
  </Dialog>
);

